import React from 'react';
import { DatePicker, Flex, Input, Select, Typography } from 'antd';
import type { Dayjs } from 'dayjs';
import { loftColors } from '../../../antd/theme';
import { StatusFilter, STATUS_OPTIONS } from './Financials.utils';

const { Text } = Typography;

interface FinancialsFiltersProps {
  searchQuery: string;
  statusFilter: StatusFilter;
  dateFrom: Dayjs | null;
  dateTo: Dayjs | null;
  displayedCount: number;
  totalCount: number;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusChange: (value: StatusFilter) => void;
  onDateFromChange: (date: Dayjs | null) => void;
  onDateToChange: (date: Dayjs | null) => void;
}

const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: 4,
  fontSize: 12,
  color: loftColors.grays[75],
};

const FinancialsFilters: React.FC<FinancialsFiltersProps> = ({
  searchQuery,
  statusFilter,
  dateFrom,
  dateTo,
  displayedCount,
  totalCount,
  onSearchChange,
  onStatusChange,
  onDateFromChange,
  onDateToChange,
}) => {
  return (
    <Flex
      gap={16}
      style={{ marginBottom: 16, flexWrap: 'wrap' }}
      align="flex-end"
    >
      <div style={{ flex: 1, minWidth: 200, maxWidth: 300 }}>
        <label htmlFor="financials-search" style={labelStyle}>
          Search by Invoice Number
        </label>
        <Input
          id="financials-search"
          placeholder="Search by invoice number or payment record ID"
          value={searchQuery}
          onChange={onSearchChange}
          allowClear
          aria-label="Search by invoice number or payment record ID"
        />
      </div>

      <div style={{ minWidth: 150 }}>
        <label htmlFor="financials-status" style={labelStyle}>
          Status
        </label>
        <Select
          id="financials-status"
          value={statusFilter}
          onChange={onStatusChange}
          style={{ width: '100%' }}
          options={STATUS_OPTIONS.map((opt) => ({
            value: opt.value,
            label: opt.label,
          }))}
        />
      </div>

      <div style={{ minWidth: 140 }}>
        <label htmlFor="financials-date-from" style={labelStyle}>
          From
        </label>
        <DatePicker
          id="financials-date-from"
          value={dateFrom}
          onChange={onDateFromChange}
          format="MM/DD/YYYY"
          placeholder="Start date"
          style={{ width: '100%' }}
          disabledDate={(current) =>
            dateTo ? current.isAfter(dateTo, 'day') : false
          }
        />
      </div>

      <div style={{ minWidth: 140 }}>
        <label htmlFor="financials-date-to" style={labelStyle}>
          To
        </label>
        <DatePicker
          id="financials-date-to"
          value={dateTo}
          onChange={onDateToChange}
          format="MM/DD/YYYY"
          placeholder="End date"
          style={{ width: '100%' }}
          disabledDate={(current) =>
            dateFrom ? current.isBefore(dateFrom, 'day') : false
          }
        />
      </div>

      <div style={{ marginLeft: 'auto' }}>
        <Text style={{ fontSize: 12, color: loftColors.grays[75] }}>
          Showing {displayedCount} of {totalCount} records
        </Text>
      </div>
    </Flex>
  );
};

export default FinancialsFilters;
